import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Piano, HandMetal, Combine, Music2 } from 'lucide-react';
export function Results() {
  const results = [{
    icon: <Piano className="w-5 h-5" data-id="element-127" />,
    text: 'Reconocer el teclado sin esfuerzo'
  }, {
    icon: <HandMetal className="w-5 h-5" data-id="element-128" />,
    text: 'Tocar acordes básicos'
  }, {
    icon: <Combine className="w-5 h-5" data-id="element-129" />,
    text: 'Coordinar ambas manos'
  }, {
    icon: <Music2 className="w-5 h-5" data-id="element-130" />,
    text: 'Tocar canciones completas'
  }];
  return <section className="py-12 bg-white relative overflow-hidden" data-id="element-131">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-beige/50 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3" data-id="element-132"></div>
      <div className="absolute bottom-0 left-0 w-48 h-48 bg-gold/5 rounded-full blur-2xl translate-y-1/3 -translate-x-1/4" data-id="element-133"></div>

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-134">
        <FadeIn data-id="element-135">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-navy mb-8" data-id="element-136">
            Lo que vas a lograr con este método
          </h2>
        </FadeIn>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-id="element-137">
          {results.map((result, index) => <FadeIn key={index} delay={index * 0.08} data-id="element-138">
              <div className="bg-beige rounded-xl p-4 flex flex-col items-center text-center gap-3 border border-navy/5" data-id="element-139">
                <div className="w-10 h-10 rounded-full bg-gold/20 text-gold flex items-center justify-center" data-id="element-140">
                  {result.icon}
                </div>
                <p className="text-sm font-semibold text-navy leading-tight" data-id="element-141">
                  {result.text}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-142">
          <p className="text-center text-base text-navy/60 mt-6 italic" data-id="element-143">
            Disfrutá tocar piano sin presión, a tu ritmo y desde tu casa
          </p>
        </FadeIn>
      </div>
    </section>;
}